export default __webpack_public_path__ + "images/wallet.svg";